<template>
    <Forms ref="searchReports"
            :title="'Filtrar dados'"
            :showHelp="true"
            :showClearButtonIcon="true"
            :ShowFooterImbo="true"
            :showSearchIcon="true"
            :showSearchButtonIcon="true"
            v-on:Clear="Clear"
            v-on:Search="Search"
            v-on:Load ="onLoad"
          >
        <div>
          <div id="form-search">

              <label  class="labelseach mt-3">Empreendimento</label>

              <multiselect v-model="empreendimentoInternoArray"  :multiple="true"  :taggable="true" placeholder="Selecione um Empreendimento" :options="empreendimentoArray" label="nomeEmpreendimento" track-by="id" :close-on-select="false">
              </multiselect>

              <label  class="labelseach mt-3">Apelido</label>

              <multiselect v-model="apelidoInternoArray"  :multiple="true"  :taggable="true" placeholder="Selecione um apelido do empreendimento" :options="apelidoArray" label="apelido" track-by="id" :close-on-select="false">
              </multiselect>
          </div>
        </div>
    </Forms>

</template>

<script>
import ChangingNamePainel from './ChangingNamePainel'
export default ChangingNamePainel
</script>

<style scoped>
.margem{
  margin-bottom: 7%;
}

#form-search{
  display: flex;
  flex-direction: column;
  align-content: center;
}

/* .labelseach{
  font: normal normal normal 16px/21px Segoe UI;
  letter-spacing: 0px;
  color: #2A2A2A;

} */

.labelseach{
  font-weight: bold;
  color: #666666;
  font-size: 14px;
  margin-bottom: 5px;
  padding-bottom: 0px;
  font-family: 'Segoe UI';
  /* margin:10px 0; */
}

.btn-periodos{
  background-color: #EBEBEB;
  height: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 130px;
  font-weight: bold;
  color: grey;
  border-radius: 25px;
  padding: 5px;
  border: 1px solid rgb(77, 77, 77);
  font-family: 'Segoe UI';
}
.btn-periodos:focus{
   background-color: #008148;
  height: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 130px;
  font-weight: bold;
  color: white;
  border-radius: 25px;
  padding: 5px;
  border: 1px solid rgb(77, 77, 77);
  font-family: 'Segoe UI';
}

.btn-periodos-active{
   background-color: #008148;
  height: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 130px;
  font-weight: bold;
  color: white;
  border-radius: 25px;
  padding: 5px;
  border: 1px solid rgb(77, 77, 77);
  font-family: 'Segoe UI';
}

.periodos {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  column-gap: 1rem;
}

#app.zopone .text-third{

  font-size: 16px;
  font-weight: normal;

}

.periodos-container{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/ChangingNameBusiness/components/ChangingNamePainel.vue